import { useState, useEffect } from 'react';

export default function Home() {
  const [calculatorData, setCalculatorData] = useState({
    faturamento: ''
  });

  const calcularEconomia = () => {
    const faturamento = parseFloat(calculatorData.faturamento) || 0;
    const perdaMensal = (faturamento * 27) / 100;
    
    return {
      perda: perdaMensal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      anual: (perdaMensal * 12).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    };
  };

  const whatsappNumber = "5514991533587";
  const getWhatsappUrl = (plan?: string) => {
    let message = "Olá! Quero saber mais sobre o BYPEDI e como posso aumentar minhas vendas sem pagar comissões.";
    if (plan) {
      message = `Olá! Quero contratar o Plano ${plan} do BYPEDI. Gostaria de mais informações.`;
    }
    return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
  };

  const [faqOpen, setFaqOpen] = useState<number | null>(null);
  const [howItWorksOpen, setHowItWorksOpen] = useState<number | null>(null);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const faqs = [
    {
      q: "O BYPEDI cobra comissão por pedido?",
      a: "Não. Aqui você paga zero comissão. Todos os pedidos entram diretamente para o seu estabelecimento, sem taxas dos aplicativos."
    },
    {
      q: "Em quanto tempo meu site fica pronto?",
      a: "O site é configurado de forma rápida. Em poucos minutos você já consegue começar a cadastrar seu cardápio e receber pedidos."
    },
    {
      q: "O BYPEDI funciona para salão e mesas?",
      a: "Sim! Temos Módulo Mesa, Módulo Garçom e QR Code na mesa, disponíveis no Plano Pro."
    },
    {
      q: "Posso integrar o BYPEDI com outros sistemas?",
      a: "Sim. Integrações estão disponíveis no Plano Business. Se precisar de algo específico, nossa equipe orienta você."
    },
    {
      q: "O pagamento online é seguro?",
      a: "Completamente seguro. Utilizamos métodos certificados, com proteção total dos dados do cliente."
    },
    {
      q: "O BYPEDI oferece suporte?",
      a: "Sim! Todos os planos têm suporte, e no Business o atendimento é prioritário."
    },
    {
      q: "Posso cancelar quando quiser?",
      a: "Sim. Você pode cancelar a qualquer momento, sem multa e sem burocracia."
    },
    {
      q: "Vocês fazem o cadastro do meu cardápio?",
      a: "Sim, oferecemos esse serviço, mas ele é consultado à parte e depende do tamanho do cardápio."
    },
    {
      q: "O sistema funciona em qualquer cidade do Brasil?",
      a: "Sim! O BYPEDI atende estabelecimentos de todo o país."
    }
  ];

  const testimonials = [
    {
      name: "Restaurante Grão e Sabor",
      text: "Depois que começamos a usar o BYPEDI, deixamos de pagar mais de R$ 4.000 por mês em comissões dos apps. Hoje a maioria dos nossos pedidos já vem do nosso próprio site.",
      image: "https://public.readdy.ai/ai/img_res/a68ed1570c253fa9bec2dffb54b9d5da.jpg"
    },
    {
      name: "Entrega de Hambúrgueres",
      text: "O robô do WhatsApp reduziu em 80% o tempo de atendimento e aumentou nossas vendas noturnas.",
      image: "https://readdy.ai/api/search-image?query=Young%20Brazilian%20burger%20shop%20owner%2C%20casual%20everyday%20clothing%2C%20natural%20smile%2C%20amateur%20photo%20quality%2C%20simple%20background%2C%20realistic%20candid%20portrait%20photography&width=80&height=80&seq=testimonial-owner-2&orientation=squarish"
    },
    {
      name: "Pizzaria La Vera",
      text: "O módulo de fidelidade trouxe clientes que foram sumidos. Virou nosso padrão.",
      image: "https://readdy.ai/api/search-image?query=Italian%20pizzeria%20owner%20in%20Brazil%2C%20casual%20work%20clothes%2C%20natural%20everyday%20photo%2C%20amateur%20photography%20style%2C%20simple%20restaurant%20setting%2C%20realistic%20candid%20portrait&width=80&height=80&seq=testimonial-owner-3&orientation=squarish"
    },
    {
      name: "Lanchonete Sabor da Casa",
      text: "Com o totem de autoatendimento, reduzimos filas e aumentamos o ticket médio em 35%. Nossos clientes adoram a praticidade!",
      image: "https://readdy.ai/api/search-image?query=Brazilian%20snack%20bar%20owner%2C%20casual%20everyday%20attire%2C%20natural%20candid%20smile%2C%20amateur%20photo%20quality%2C%20simple%20background%2C%20realistic%20everyday%20portrait%20photography&width=80&height=80&seq=testimonial-owner-4&orientation=squarish"
    },
    {
      name: "Restaurante Tempero Mineiro",
      text: "O QR Code nas mesas revolucionou nosso atendimento. Os clientes fazem pedidos direto pelo celular e o garçom tem mais tempo para atender melhor.",
      image: "https://readdy.ai/api/search-image?query=Brazilian%20traditional%20restaurant%20owner%2C%20casual%20work%20clothing%2C%20natural%20everyday%20smile%2C%20amateur%20photography%20quality%2C%20simple%20restaurant%20background%2C%20realistic%20candid%20portrait&width=80&height=80&seq=testimonial-owner-5&orientation=squarish"
    },
    {
      name: "Hamburgueria Artesanal",
      text: "Antes perdíamos 30% do faturamento em comissões. Agora esse dinheiro fica conosco e investimos em melhorias. Melhor decisão que tomamos!",
      image: "https://readdy.ai/api/search-image?query=Young%20gourmet%20burger%20chef%2C%20casual%20everyday%20style%2C%20natural%20candid%20expression%2C%20amateur%20photo%20quality%2C%20simple%20background%2C%20realistic%20everyday%20portrait%20photography&width=80&height=80&seq=testimonial-owner-6&orientation=squarish"
    },
    {
      name: "Padaria do Bairro",
      text: "O sistema de pedidos online aumentou nossas vendas de café da manhã em 60%. Agora recebemos encomendas até de madrugada!",
      image: "https://readdy.ai/api/search-image?query=Brazilian%20bakery%20owner%2C%20flour-dusted%20apron%2C%20warm%20genuine%20smile%2C%20amateur%20selfie%20style%20photo%2C%20bakery%20background%2C%20realistic%20everyday%20portrait%20photography&width=80&height=80&seq=testimonial-owner-7&orientation=squarish"
    },
    {
      name: "Açaíteria Tropical",
      text: "Com o BYPEDI conseguimos organizar melhor os pedidos de açaí. As vendas de delivery triplicaram desde que saímos dos aplicativos caros.",
      image: "https://readdy.ai/api/search-image?query=Young%20Brazilian%20a%C3%A7a%C3%AD%20shop%20owner%2C%20colorful%20casual%20clothing%2C%20natural%20happy%20expression%2C%20amateur%20photo%20quality%2C%20tropical%20fruit%20background%2C%20realistic%20candid%20portrait%20photography&width=80&height=80&seq=testimonial-owner-8&orientation=squarish"
    },
    {
      name: "Churrascaria Gaúcha",
      text: "O módulo de mesa facilitou muito o atendimento no salão. Os clientes pedem direto pelo QR Code e a conta fica organizada automaticamente.",
      image: "https://readdy.ai/api/search-image?query=Brazilian%20barbecue%20restaurant%20owner%2C%20traditional%20gaucho%20style%20clothing%2C%20friendly%20natural%20smile%2C%20amateur%20photography%2C%20rustic%20restaurant%20setting%2C%20realistic%20everyday%20portrait&width=80&height=80&seq=testimonial-owner-9&orientation=squarish"
    },
    {
      name: "Sorveteria Gelato",
      text: "Nossos clientes amam fazer pedidos pelo site. As vendas de delivery triplicaram desde que saímos dos aplicativos caros.",
      image: "https://readdy.ai/api/search-image?query=Brazilian%20ice%20cream%20shop%20owner%2C%20colorful%20apron%2C%20cheerful%20natural%20expression%2C%20amateur%20photo%20quality%2C%20ice%20cream%20parlor%20background%2C%20realistic%20candid%20portrait%20photography&width=80&height=80&seq=testimonial-owner-10&orientation=squarish"
    },
    {
      name: "Restaurante Japonês Sakura",
      text: "O controle de estoque integrado nos ajudou muito. Agora sabemos exatamente quando repor ingredientes e não perdemos vendas.",
      image: "https://readdy.ai/api/search-image?query=Brazilian%20Japanese%20restaurant%20owner%2C%20simple%20work%20attire%2C%20calm%20professional%20smile%2C%20amateur%20photo%20quality%2C%20clean%20restaurant%20background%2C%20realistic%20everyday%20portrait&width=80&height=80&seq=testimonial-owner-11&orientation=squarish"
    },
    {
      name: "Food Truck Sabores da Rua",
      text: "Mesmo sendo um food truck, conseguimos ter nosso próprio sistema de pedidos. Os clientes já sabem onde estamos e fazem pedidos antecipados!",
      image: "https://readdy.ai/api/search-image?query=Brazilian%20food%20truck%20owner%2C%20casual%20street%20food%20vendor%20clothing%2C%20energetic%20natural%20smile%2C%20amateur%20photo%20style%2C%20food%20truck%20background%2C%20realistic%20candid%20portrait%20photography&width=80&height=80&seq=testimonial-owner-12&orientation=squarish"
    }
  ];

  // Auto-rotate testimonials every 4 seconds, showing 3 at a time
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 3) % testimonials.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 3) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 3 + testimonials.length) % testimonials.length);
  };

  // Get current 3 testimonials to display
  const getCurrentTestimonials = () => {
    const current = [];
    for (let i = 0; i < 3; i++) {
      current.push(testimonials[(currentTestimonial + i) % testimonials.length]);
    }
    return current;
  };

  return (
    <div className="min-h-screen bg-white">
      {/* WhatsApp Fixo */}
      <a 
        href={getWhatsappUrl()}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-3 md:p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 w-14 h-14 md:w-16 md:h-16 flex items-center justify-center cursor-pointer"
        style={{ animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' }}
      >
        <i className="fab fa-whatsapp text-2xl md:text-3xl"></i>
      </a>

      {/* Header/Navigation - Compacto e Rente */}
      <header className="bg-gradient-to-r from-amber-500 via-amber-600 to-yellow-500 shadow-2xl py-1 md:py-2 sticky top-0 z-40">
        <div className="container mx-auto px-1 md:px-2 flex justify-between items-center">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/8ae6a4d61264bced6ad2678c7de077f2/1fa7310747d5d29c80fc98c760d9f093.png" 
              alt="BYPEDI Logo" 
              className="h-20 md:h-24"
            />
          </div>
          <a 
            href={getWhatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-black hover:bg-gray-900 text-white px-3 md:px-6 py-2 md:py-3 rounded-full font-bold transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl border-2 border-white text-xs md:text-base"
          >
            <i className="fab fa-whatsapp mr-1 md:mr-2"></i>
            Quero iniciar agora
          </a>
        </div>
      </header>

      {/* SEÇÃO 1 - HERÓI */}
      <section 
        className="relative py-16 md:py-24 bg-cover bg-center overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.65) 100%), url('https://readdy.ai/api/search-image?query=Modern%20restaurant%20interior%20with%20customer%20ordering%20at%20self-service%20kiosk%20totem%2C%20another%20customer%20scanning%20QR%20code%20menu%20at%20table%20with%20smartphone%2C%20delivery%20person%20with%20thermal%20bag%20leaving%20restaurant%2C%20person%20ordering%20food%20on%20mobile%20phone%20app%2C%20realistic%20professional%20photography%2C%20high%20quality%20commercial%20image%20showing%20complete%20food%20service%20ecosystem%2C%20warm%20restaurant%20lighting&width=1920&height=800&seq=hero-bypedi-complete&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
        <div className="container mx-auto px-4 text-center text-white relative z-10 max-w-6xl">
          <h1 className="text-3xl md:text-5xl lg:text-7xl font-extrabold mb-4 md:mb-6 leading-tight drop-shadow-2xl text-amber-400">
            Seu Delivery — Suas vendas, seu lucro!
          </h1>
          <h2 className="text-xl md:text-3xl lg:text-5xl font-bold mb-6 md:mb-8 leading-tight drop-shadow-2xl">
            Pare de perder dinheiro! Tenha sua própria plataforma com controle total e sem pagar comissões!
          </h2>
          <p className="text-lg md:text-2xl lg:text-3xl mb-8 md:mb-12 max-w-4xl mx-auto text-gray-100 leading-relaxed drop-shadow-lg font-semibold">
            Com a ByPedi, você tem uma solução completa!
          </p>
          <a 
            href={getWhatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-amber-500 hover:bg-amber-600 text-black px-6 md:px-12 py-3 md:py-5 rounded-full text-base md:text-xl font-bold transition-all duration-300 transform hover:scale-110 shadow-2xl whitespace-nowrap cursor-pointer"
            style={{ animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' }}
          >
            QUERO AUMENTAR MINHAS VENDAS
          </a>
        </div>
      </section>

      {/* SEÇÃO 2 - Por que escolher o BYPEDI */}
      <section className="py-12 md:py-16 relative overflow-hidden bg-white">
        <div className="container mx-auto px-4 relative z-10 max-w-7xl">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-8 md:mb-12 text-gray-900">🎯 Por que escolher o BYPEDI?</h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-gradient-to-br from-white to-amber-50 p-6 md:p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-amber-100">
              <div className="mb-4 md:mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Restaurant%20owner%20celebrating%20profit%20growth%2C%20Brazilian%20business%20person%20happy%20with%20money%20savings%2C%20no%20commission%20fees%20concept%2C%20realistic%20professional%20photography%2C%20high%20quality%20commercial%20image%20showing%20financial%20success&width=400&height=300&seq=benefit-no-commission&orientation=landscape"
                  alt="Sem comissões"
                  className="w-full h-40 md:h-48 object-cover rounded-2xl"
                />
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4 text-gray-900">Sem comissões</h3>
              <p className="text-gray-700 text-base md:text-lg mb-2 md:mb-3">Pare de entregar parte do seu lucro para apps de entrega. Aqui, o lucro é 100% seu.</p>
              <p className="text-gray-600 italic text-sm md:text-base">→ Aumente seu lucro sem mudar sua operação.</p>
            </div>
            
            <div className="bg-gradient-to-br from-white to-blue-50 p-6 md:p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-blue-100">
              <div className="mb-4 md:mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Restaurant%20manager%20controlling%20multiple%20order%20channels%20on%20tablet%20dashboard%2C%20delivery%20salon%20and%20counter%20orders%20centralized%2C%20real-time%20order%20management%20system%2C%20realistic%20professional%20photography%2C%20high%20quality%20commercial%20image&width=400&height=300&seq=benefit-control&orientation=landscape"
                  alt="Controle total da operação"
                  className="w-full h-40 md:h-48 object-cover rounded-2xl"
                />
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4 text-gray-900">Controle total da operação</h3>
              <p className="text-gray-700 text-base md:text-lg mb-2 md:mb-3">Receba pedidos no delivery, salão ou balcão com autonomia e tudo centralizado.</p>
              <p className="text-gray-600 italic text-sm md:text-base">→ Tudo em tempo real, do pedido à entrega.</p>
            </div>
            
            <div className="bg-gradient-to-br from-white to-green-50 p-6 md:p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-green-100">
              <div className="mb-4 md:mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20restaurant%20website%20on%20laptop%20and%20smartphone%20screens%2C%20beautiful%20food%20menu%20with%20photos%20combos%20and%20coupons%2C%20modern%20e-commerce%20food%20ordering%20platform%2C%20realistic%20professional%20photography%2C%20high%20quality%20commercial%20image&width=400&height=300&seq=benefit-website&orientation=landscape"
                  alt="Site próprio de pedidos"
                  className="w-full h-40 md:h-48 object-cover rounded-2xl"
                />
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4 text-gray-900">Site próprio de pedidos</h3>
              <p className="text-gray-700 text-base md:text-lg mb-2 md:mb-3">Profissional, rápido, com fotos, combos, cupons e integrações.</p>
              <p className="text-gray-600 italic text-sm md:text-base">→ Seu cardápio sempre atualizado e com muitas ferramentas para vender mais.</p>
            </div>
            
            <div className="bg-gradient-to-br from-white to-purple-50 p-6 md:p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-purple-100">
              <div className="mb-4 md:mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Restaurant%20using%20QR%20code%20ordering%20system%20and%20self-service%20kiosk%2C%20customers%20ordering%20quickly%2C%20automated%20food%20service%20technology%2C%20increased%20sales%20efficiency%2C%20realistic%20professional%20photography%2C%20high%20quality%20commercial%20image&width=400&height=300&seq=benefit-sales&orientation=landscape"
                  alt="Mais vendas, menos custos"
                  className="w-full h-40 md:h-48 object-cover rounded-2xl"
                />
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4 text-gray-900">Mais vendas, menos custos</h3>
              <p className="text-gray-700 text-base md:text-lg mb-2 md:mb-3">Links de pedido, QR Code por mesa, totens inteligentes e automações que trabalham por você.</p>
              <p className="text-gray-600 italic text-sm md:text-base">→ Vendas mais rápidas e com muito mais eficiência para seu negócio crescer.</p>
            </div>
            
            <div className="bg-gradient-to-br from-white to-red-50 p-6 md:p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-red-100">
              <div className="mb-4 md:mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Efficient%20restaurant%20service%20with%20chatbot%20on%20smartphone%2C%20customer%20self-ordering%20via%20QR%20code%2C%20automated%20ordering%20system%2C%20fast%20customer%20service%2C%20realistic%20professional%20photography%2C%20high%20quality%20commercial%20image&width=400&height=300&seq=benefit-service&orientation=landscape"
                  alt="Atendimento mais eficiente"
                  className="w-full h-40 md:h-48 object-cover rounded-2xl"
                />
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4 text-gray-900">Atendimento mais eficiente</h3>
              <p className="text-gray-700 text-base md:text-lg mb-2 md:mb-3">Chat inteligente, autoatendimento, pedido via QR Code e carrinho completo.</p>
              <p className="text-gray-600 italic text-sm md:text-base">→ Mais agilidade sem depender de equipe extra.</p>
            </div>
            
            <div className="bg-gradient-to-br from-white to-teal-50 p-6 md:p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-teal-100">
              <div className="mb-4 md:mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Small%20food%20truck%20and%20large%20restaurant%20chain%20side%20by%20side%2C%20diverse%20food%20business%20sizes%2C%20small%20family-owned%20food%20stand%20next%20to%20modern%20restaurant%20franchise%20building%2C%20scalable%20business%20solution%20concept%2C%20realistic%20professional%20photography%2C%20high%20quality%20commercial%20image%20showing%20business%20growth%20from%20small%20to%20large&width=400&height=300&seq=benefit-scalable-both&orientation=landscape"
                  alt="Perfeito para qualquer tamanho de negócio"
                  className="w-full h-40 md:h-48 object-cover rounded-2xl"
                />
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4 text-gray-900">Perfeito para qualquer tamanho de negócio</h3>
              <p className="text-gray-700 text-base md:text-lg mb-2 md:mb-3">Desde pequenas lanchonetes até grandes redes de restaurantes.</p>
              <p className="text-gray-600 italic text-sm md:text-base">→ Do pequeno delivery à rede de franquias.</p>
            </div>
          </div>
        </div>
      </section>

      {/* SEÇÃO 3 - Antes e Depois */}
      <section className="py-12 md:py-16 relative overflow-hidden bg-gradient-to-br from-gray-50 to-white">
        <div className="container mx-auto px-4 max-w-7xl">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-3 md:mb-4 text-gray-900">🔥 Antes e Depois de usar o BYPEDI</h2>
          <p className="text-center text-lg md:text-xl text-gray-600 mb-8 md:mb-12">Veja a transformação do seu negócio</p>
          
          <div className="grid md:grid-cols-2 gap-6 md:gap-8">
            {/* Antes */}
            <div className="bg-gradient-to-br from-red-50 to-red-100 p-6 md:p-8 rounded-3xl shadow-xl border-2 border-red-300">
              <h3 className="text-2xl md:text-3xl font-bold mb-6 md:mb-8 text-red-800 text-center">❌ Antes</h3>
              <div className="space-y-3 md:space-y-4">
                <div className="flex items-start bg-white/50 p-3 md:p-4 rounded-xl">
                  <i className="ri-close-circle-fill text-red-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1"></i>
                  <p className="text-gray-800 text-base md:text-lg font-semibold">Pedidos travando no WhatsApp</p>
                </div>
                <div className="flex items-start bg-white/50 p-3 md:p-4 rounded-xl">
                  <i className="ri-close-circle-fill text-red-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1"></i>
                  <p className="text-gray-800 text-base md:text-lg font-semibold">Falta de controle e erros manuais</p>
                </div>
                <div className="flex items-start bg-white/50 p-3 md:p-4 rounded-xl">
                  <i className="ri-close-circle-fill text-red-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1"></i>
                  <p className="text-gray-800 text-base md:text-lg font-semibold">Dependência dos aplicativos</p>
                </div>
                <div className="flex items-start bg-white/50 p-3 md:p-4 rounded-xl">
                  <i className="ri-close-circle-fill text-red-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1"></i>
                  <p className="text-gray-800 text-base md:text-lg font-semibold">Alto custo com comissões</p>
                </div>
                <div className="flex items-start bg-white/50 p-3 md:p-4 rounded-xl">
                  <i className="ri-close-circle-fill text-red-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1"></i>
                  <p className="text-gray-800 text-base md:text-lg font-semibold">Filas e demora no atendimento</p>
                </div>
                <div className="flex items-start bg-white/50 p-3 md:p-4 rounded-xl">
                  <i className="ri-close-circle-fill text-red-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1"></i>
                  <p className="text-gray-800 text-base md:text-lg font-semibold">Falta de organização e retrabalho</p>
                </div>
              </div>
            </div>

            {/* Depois */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 md:p-8 rounded-3xl shadow-xl border-2 border-green-300">
              <h3 className="text-2xl md:text-3xl font-bold mb-6 md:mb-8 text-green-800 text-center">✅ Depois</h3>
              <div className="space-y-3 md:space-y-4">
                <div className="flex items-start bg-white/50 p-3 md:p-4 rounded-xl">
                  <i className="ri-checkbox-circle-fill text-green-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1"></i>
                  <p className="text-gray-800 text-base md:text-lg font-semibold">Plataforma própria sem comissão</p>
                </div>
                <div className="flex items-start bg-white/50 p-3 md:p-4 rounded-xl">
                  <i className="ri-checkbox-circle-fill text-green-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1"></i>
                  <p className="text-gray-800 text-base md:text-lg font-semibold">Pedidos organizados e automatizados</p>
                </div>
                <div className="flex items-start bg-white/50 p-3 md:p-4 rounded-xl">
                  <i className="ri-checkbox-circle-fill text-green-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1"></i>
                  <p className="text-gray-800 text-base md:text-lg font-semibold">QR Code por mesa e para delivery</p>
                </div>
                <div className="flex items-start bg-white/50 p-3 md:p-4 rounded-xl">
                  <i className="ri-checkbox-circle-fill text-green-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1"></i>
                  <p className="text-gray-800 text-base md:text-lg font-semibold">Totem de autoatendimento</p>
                </div>
                <div className="flex items-start bg-white/50 p-3 md:p-4 rounded-xl">
                  <i className="ri-checkbox-circle-fill text-green-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1"></i>
                  <p className="text-gray-800 text-base md:text-lg font-semibold">Aumento real do ticket médio</p>
                </div>
                <div className="flex items-start bg-white/50 p-3 md:p-4 rounded-xl">
                  <i className="ri-checkbox-circle-fill text-green-500 text-xl md:text-2xl mr-3 md:mr-4 mt-1"></i>
                  <p className="text-gray-800 text-base md:text-lg font-semibold">Mais vendas, mais autonomia</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="text-center mt-8 md:mt-12">
            <a 
              href={getWhatsappUrl()}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white px-6 md:px-12 py-3 md:py-5 rounded-full font-bold text-base md:text-xl transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer inline-block"
            >
              Quero essa transformação agora
            </a>
          </div>
        </div>
      </section>

      {/* SEÇÃO 4 - Prova Social - Carrossel com 3 depoimentos */}
      <section className="py-12 md:py-16 relative overflow-hidden bg-gradient-to-br from-white to-gray-50">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-8 md:mb-12 text-gray-900">O que nossos clientes dizem</h2>
          
          <div className="relative">
            <div className="grid md:grid-cols-3 gap-4 md:gap-6">
              {getCurrentTestimonials().map((testimonial, index) => (
                <div key={index} className="bg-white p-6 md:p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-200">
                  <div className="flex flex-col items-center mb-4 md:mb-6">
                    <img 
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-12 h-12 md:w-16 md:h-16 rounded-full object-cover mb-3 md:mb-4 border-4 border-amber-200"
                    />
                    <div className="text-center">
                      <h4 className="font-bold text-base md:text-lg text-gray-900">{testimonial.name}</h4>
                      <div className="text-amber-500 text-lg md:text-xl">⭐⭐⭐⭐⭐</div>
                    </div>
                  </div>
                  <p className="text-gray-700 italic text-sm md:text-base leading-relaxed text-center">
                    "{testimonial.text}"
                  </p>
                </div>
              ))}
            </div>
            
            {/* Controles do Carrossel */}
            <button
              onClick={prevTestimonial}
              className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-2 md:-translate-x-4 bg-amber-500 hover:bg-amber-600 text-white w-10 h-10 md:w-12 md:h-12 rounded-full shadow-xl transition-all duration-300 hover:scale-110 flex items-center justify-center cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-xl md:text-2xl"></i>
            </button>
            <button
              onClick={nextTestimonial}
              className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-2 md:translate-x-4 bg-amber-500 hover:bg-amber-600 text-white w-10 h-10 md:w-12 md:h-12 rounded-full shadow-xl transition-all duration-300 hover:scale-110 flex items-center justify-center cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-xl md:text-2xl"></i>
            </button>
          </div>
          
          {/* Indicadores */}
          <div className="flex justify-center mt-6 md:mt-8 space-x-2">
            {Array.from({ length: Math.ceil(testimonials.length / 3) }).map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index * 3)}
                className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  Math.floor(currentTestimonial / 3) === index ? 'bg-amber-500 w-6 md:w-8' : 'bg-gray-300'
                }`}
              ></button>
            ))}
          </div>
          
          <div className="text-center mt-8 md:mt-12">
            <a 
              href={getWhatsappUrl()}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black px-6 md:px-10 py-3 md:py-4 rounded-full font-bold text-base md:text-lg transition-all duration-300 transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer inline-block"
            >
              Quero resultados como estes
            </a>
          </div>
        </div>
      </section>

      {/* SEÇÃO 5 - Como Funciona na Prática - Visual */}
      <section className="py-12 md:py-16 relative overflow-hidden bg-gradient-to-br from-blue-50 via-white to-blue-50">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-3 md:mb-4 text-gray-900">Como funciona na prática?</h2>
          <p className="text-center text-lg md:text-xl text-gray-600 mb-8 md:mb-12">Veja como é simples começar a vender mais</p>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-8 md:mb-12">
            {/* Passo 1 */}
            <div className="relative">
              <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-2 border-blue-200 h-full">
                <div className="absolute -top-4 md:-top-6 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-blue-500 to-blue-600 text-white w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center text-xl md:text-2xl font-bold shadow-lg">
                  1
                </div>
                <div className="mt-4 mb-4 md:mb-6">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Customer%20service%20representative%20helping%20client%20via%20WhatsApp%20on%20smartphone%2C%20friendly%20Brazilian%20professional%2C%20modern%20office%20setting%2C%20realistic%20business%20photography%2C%20high%20quality%20commercial%20image%20showing%20digital%20communication&width=400&height=300&seq=step-1-whatsapp&orientation=landscape"
                    alt="Passo 1"
                    className="w-full h-36 md:h-48 object-cover rounded-2xl"
                  />
                </div>
                <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3 text-gray-900 text-center">Fale com nosso time pelo WhatsApp</h3>
                <p className="text-gray-700 text-center leading-relaxed text-sm md:text-base">Nossa equipe ativa sua conta, configura o ambiente e te ajuda no início.</p>
              </div>
            </div>

            {/* Passo 2 */}
            <div className="relative">
              <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-2 border-green-200 h-full">
                <div className="absolute -top-4 md:-top-6 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-green-500 to-green-600 text-white w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center text-xl md:text-2xl font-bold shadow-lg">
                  2
                </div>
                <div className="mt-4 mb-4 md:mb-6">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Modern%20restaurant%20website%20being%20created%20on%20laptop%20screen%2C%20professional%20web%20design%20interface%2C%20food%20delivery%20platform%20dashboard%2C%20realistic%20technology%20photography%2C%20high%20quality%20commercial%20image%20showing%20digital%20platform%20setup&width=400&height=300&seq=step-2-website&orientation=landscape"
                    alt="Passo 2"
                    className="w-full h-36 md:h-48 object-cover rounded-2xl"
                  />
                </div>
                <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3 text-gray-900 text-center">Criamos seu site e liberamos os módulos</h3>
                <p className="text-gray-700 text-center leading-relaxed text-sm md:text-base">Site de delivery, robô WhatsApp, mesa, PDV, fidelização e muito mais.</p>
              </div>
            </div>

            {/* Passo 3 */}
            <div className="relative">
              <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-2 border-purple-200 h-full">
                <div className="absolute -top-4 md:-top-6 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-purple-500 to-purple-600 text-white w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center text-xl md:text-2xl font-bold shadow-lg">
                  3
                </div>
                <div className="mt-4 mb-4 md:mb-6">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Restaurant%20owner%20adding%20menu%20items%20to%20digital%20platform%20on%20tablet%2C%20food%20photos%20being%20uploaded%2C%20professional%20kitchen%20background%2C%20realistic%20business%20photography%2C%20high%20quality%20commercial%20image%20showing%20menu%20management&width=400&height=300&seq=step-3-menu&orientation=landscape"
                    alt="Passo 3"
                    className="w-full h-36 md:h-48 object-cover rounded-2xl"
                  />
                </div>
                <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3 text-gray-900 text-center">Cadastre o cardápio (ou deixe com a gente)</h3>
                <p className="text-gray-700 text-center leading-relaxed text-sm md:text-base">Você faz direto no painel ou opta pelo serviço adicional de cadastro.</p>
              </div>
            </div>

            {/* Passo 4 */}
            <div className="relative">
              <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-2 border-amber-200 h-full">
                <div className="absolute -top-4 md:-top-6 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-amber-500 to-amber-600 text-white w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center text-xl md:text-2xl font-bold shadow-lg">
                  4
                </div>
                <div className="mt-4 mb-4 md:mb-6">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Happy%20restaurant%20receiving%20multiple%20online%20orders%20on%20smartphone%20and%20tablet%2C%20order%20notifications%2C%20successful%20food%20delivery%20business%2C%20realistic%20photography%2C%20high%20quality%20commercial%20image%20showing%20business%20growth%20and%20sales&width=400&height=300&seq=step-4-orders&orientation=landscape"
                    alt="Passo 4"
                    className="w-full h-36 md:h-48 object-cover rounded-2xl"
                  />
                </div>
                <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3 text-gray-900 text-center">Comece a receber pedidos imediatamente</h3>
                <p className="text-gray-700 text-center leading-relaxed text-sm md:text-base">O sistema funciona 24h por dia, integrado e pronto para vender mais.</p>
              </div>
            </div>
          </div>
          
          <div className="text-center">
            <a 
              href={getWhatsappUrl()}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-6 md:px-12 py-3 md:py-5 rounded-full font-bold text-base md:text-xl transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer inline-block mb-4"
            >
              👉 Quero ativar meu BYPEDI agora
            </a>
          </div>
        </div>
      </section>

      {/* SEÇÃO 6 - Calculadora de Economia */}
      <section className="py-12 md:py-16 relative overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(135deg, rgba(251, 191, 36, 0.95) 0%, rgba(245, 158, 11, 0.95) 100%), url('https://readdy.ai/api/search-image?query=Money%20savings%20concept%20for%20restaurant%20business%2C%20Brazilian%20currency%20notes%20and%20coins%2C%20financial%20growth%20charts%2C%20calculator%20and%20smartphone%2C%20professional%20business%20finance%20photography%2C%20realistic%20high%20quality%20image&width=1920&height=600&seq=calculator-bg&orientation=landscape')`
          }}
        ></div>
        <div className="container mx-auto px-4 relative z-10 max-w-4xl">
          <div className="bg-white/95 backdrop-blur-sm p-6 md:p-10 rounded-3xl shadow-2xl">
            <div className="text-center mb-6 md:mb-10">
              <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4 text-gray-900">💰 Calculadora de Economia</h2>
              <p className="text-lg md:text-xl text-gray-700">Descubra quanto você está perdendo para as plataformas de delivery</p>
            </div>
            
            <div className="space-y-6 md:space-y-8">
              <div>
                <label className="block text-base md:text-lg font-bold mb-2 md:mb-3 text-gray-900">Qual seu faturamento médio mensal com delivery?</label>
                <div className="relative">
                  <span className="absolute left-3 md:left-4 top-1/2 transform -translate-y-1/2 text-xl md:text-2xl font-bold text-gray-600">R$</span>
                  <input 
                    type="number"
                    value={calculatorData.faturamento}
                    onChange={(e) => setCalculatorData({faturamento: e.target.value})}
                    className="w-full pl-12 md:pl-16 pr-4 md:pr-6 py-3 md:py-5 border-3 border-amber-300 rounded-2xl text-xl md:text-2xl font-bold focus:outline-none focus:border-amber-500 focus:ring-4 focus:ring-amber-200 transition-all"
                    placeholder="15.000"
                  />
                </div>
              </div>
              
              {calculatorData.faturamento && parseFloat(calculatorData.faturamento) > 0 && (
                <div className="bg-gradient-to-br from-red-50 to-red-100 p-6 md:p-8 rounded-2xl border-4 border-red-400 shadow-xl">
                  <div className="text-center mb-4 md:mb-6">
                    <h3 className="text-xl md:text-2xl font-bold text-red-800 mb-2">🚨 ALERTA DE PREJUÍZO</h3>
                    <p className="text-base md:text-lg text-red-700">Você está perdendo por mês:</p>
                  </div>
                  <div className="text-center mb-4 md:mb-6">
                    <p className="text-3xl md:text-5xl font-extrabold text-red-600 mb-2">{calcularEconomia().perda}</p>
                    <p className="text-base md:text-xl text-red-700 font-semibold">em comissões para plataformas de delivery</p>
                  </div>
                  <div className="bg-red-200 p-4 md:p-6 rounded-xl mb-4 md:mb-6">
                    <p className="text-center text-lg md:text-2xl font-bold text-red-900">
                      Em 1 ano: {calcularEconomia().anual}
                    </p>
                  </div>
                  <div className="bg-gradient-to-r from-green-500 to-green-600 p-4 md:p-6 rounded-xl">
                    <p className="text-center text-base md:text-xl font-bold text-white">
                      ✅ Com o BYPEDI, esse valor volta 100% para o seu bolso!
                    </p>
                  </div>
                </div>
              )}
            </div>
            
            <div className="text-center mt-6 md:mt-10">
              <a 
                href={getWhatsappUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-4 md:px-12 py-3 md:py-5 rounded-full font-bold text-sm md:text-xl transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer inline-block"
              >
                🔥 Quero parar de perder dinheiro
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SEÇÃO 7 - Planos */}
      <section className="py-12 md:py-16 relative overflow-hidden bg-gradient-to-br from-white via-gray-50 to-white">
        <div className="container mx-auto px-4 max-w-7xl">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-3 md:mb-4 text-gray-900">Escolha seu plano</h2>
          <p className="text-center text-lg md:text-xl text-gray-700 mb-8 md:mb-12">Seu site próprio se paga sozinho no primeiro mês</p>
          
          <div className="grid md:grid-cols-3 gap-6 md:gap-8">
            {/* Plano Start */}
            <div className="bg-white rounded-3xl p-6 md:p-8 relative shadow-xl hover:shadow-2xl transition-all duration-300 border-2 border-gray-200">
              <h3 className="text-xl md:text-2xl font-bold mb-2 md:mb-3 text-gray-900">PLANO START</h3>
              <div className="text-3xl md:text-4xl font-bold text-amber-600 mb-3 md:mb-4">R$ 179,90</div>
              <p className="text-gray-700 mb-4 md:mb-6 text-base md:text-lg leading-relaxed">"Tudo o que você precisa para vender no delivery sem pagar comissão."</p>
              
              <ul className="space-y-2 md:space-y-3 mb-6 md:mb-8">
                <li className="flex items-start"><i className="ri-check-line text-green-500 mr-2 md:mr-3 text-lg md:text-xl mt-1"></i><span className="text-gray-800 text-sm md:text-base">Site para entrega de pedidos</span></li>
                <li className="flex items-start"><i className="ri-check-line text-green-500 mr-2 md:mr-3 text-lg md:text-xl mt-1"></i><span className="text-gray-800 text-sm md:text-base">Painel de administração</span></li>
                <li className="flex items-start"><i className="ri-check-line text-green-500 mr-2 md:mr-3 text-lg md:text-xl mt-1"></i><span className="text-gray-800 text-sm md:text-base">Cupons de desconto</span></li>
                <li className="flex items-start"><i className="ri-check-line text-green-500 mr-2 md:mr-3 text-lg md:text-xl mt-1"></i><span className="text-gray-800 text-sm md:text-base">Fidelização</span></li>
                <li className="flex items-start"><i className="ri-check-line text-green-500 mr-2 md:mr-3 text-lg md:text-xl mt-1"></i><span className="text-gray-800 text-sm md:text-base">Abandono de carrinho</span></li>
                <li className="flex items-start"><i className="ri-check-line text-green-500 mr-2 md:mr-3 text-lg md:text-xl mt-1"></i><span className="text-gray-800 text-sm md:text-base">Relatórios</span></li>
                <li className="flex items-start"><i className="ri-check-line text-green-500 mr-2 md:mr-3 text-lg md:text-xl mt-1"></i><span className="text-gray-800 text-sm md:text-base">Códigos QR - Entrega</span></li>
              </ul>
              
              <a 
                href={getWhatsappUrl('Start')}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-gray-800 hover:bg-gray-900 text-white py-3 md:py-4 rounded-2xl font-bold transition-all duration-300 block text-center whitespace-nowrap cursor-pointer text-base md:text-lg"
              >
                Contratar agora
              </a>
            </div>

            {/* Plano Pro - Destaque */}
            <div className="bg-gradient-to-br from-amber-50 to-white rounded-3xl p-6 md:p-8 relative transform md:scale-105 shadow-2xl border-4 border-amber-500">
              <div className="absolute -top-4 md:-top-5 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-amber-500 to-amber-600 text-black px-4 md:px-6 py-1 md:py-2 rounded-full text-xs md:text-sm font-bold shadow-lg whitespace-nowrap">
                CAMPEÃO DE VENDAS
              </div>
              <div className="absolute -top-2 md:-top-3 -right-2 md:-right-3 bg-gradient-to-r from-red-500 to-red-600 text-white px-3 md:px-4 py-1 md:py-2 rounded-full text-xs md:text-sm font-bold shadow-lg whitespace-nowrap">
                + Vendido
              </div>
              
              <h3 className="text-xl md:text-2xl font-bold mb-2 md:mb-3 text-gray-900 mt-3 md:mt-4">PLANO PRO</h3>
              <div className="text-3xl md:text-4xl font-bold text-amber-600 mb-3 md:mb-4">R$ 214,90</div>
              <p className="text-gray-700 mb-4 md:mb-6 text-base md:text-lg leading-relaxed">"O preferido pelos restaurantes — mais vendas, menos trabalho."</p>
              
              <ul className="space-y-2 md:space-y-3 mb-6 md:mb-8">
                <li className="flex items-start"><i className="ri-check-line text-green-500 mr-2 md:mr-3 text-lg md:text-xl mt-1"></i><span className="text-gray-800 font-semibold text-sm md:text-base">Tudo do Start</span></li>
                <li className="flex items-start"><i className="ri-add-line text-amber-600 mr-2 md:mr-3 text-lg md:text-xl mt-1 font-bold"></i><span className="text-gray-800 text-sm md:text-base">Robô de WhatsApp</span></li>
                <li className="flex items-start"><i className="ri-add-line text-amber-600 mr-2 md:mr-3 text-lg md:text-xl mt-1 font-bold"></i><span className="text-gray-800 text-sm md:text-base">Envio de marketing</span></li>
                <li className="flex items-start"><i className="ri-add-line text-amber-600 mr-2 md:mr-3 text-lg md:text-xl mt-1 font-bold"></i><span className="text-gray-800 text-sm md:text-base">PDV</span></li>
                <li className="flex items-start"><i className="ri-add-line text-amber-600 mr-2 md:mr-3 text-lg md:text-xl mt-1 font-bold"></i><span className="text-gray-800 text-sm md:text-base">Mesa do Garçom</span></li>
                <li className="flex items-start"><i className="ri-add-line text-amber-600 mr-2 md:mr-3 text-lg md:text-xl mt-1 font-bold"></i><span className="text-gray-800 text-sm md:text-base">Códigos QR - Mesa</span></li>
                <li className="flex items-start"><i className="ri-add-line text-amber-600 mr-2 md:mr-3 text-lg md:text-xl mt-1 font-bold"></i><span className="text-gray-800 text-sm md:text-base">Estoque</span></li>
              </ul>
              
              <a 
                href={getWhatsappUrl('Pro')}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black py-4 md:py-5 rounded-2xl font-bold transition-all duration-300 block text-center whitespace-nowrap cursor-pointer text-base md:text-lg shadow-xl"
              >
                Contratar agora
              </a>
            </div>

            {/* Plano Business */}
            <div className="bg-white rounded-3xl p-6 md:p-8 relative shadow-xl hover:shadow-2xl transition-all duration-300 border-2 border-gray-200">
              <h3 className="text-xl md:text-2xl font-bold mb-2 md:mb-3 text-gray-900">PLANO BUSINESS</h3>
              <div className="text-3xl md:text-4xl font-bold text-amber-600 mb-3 md:mb-4">R$ 287,90</div>
              <p className="text-gray-700 mb-4 md:mb-6 text-base md:text-lg leading-relaxed">"Alta performance para quem exige escala e operação avançada."</p>
              
              <ul className="space-y-2 md:space-y-3 mb-6 md:mb-8">
                <li className="flex items-start"><i className="ri-check-line text-green-500 mr-2 md:mr-3 text-lg md:text-xl mt-1"></i><span className="text-gray-800 font-semibold text-sm md:text-base">Tudo do Pro</span></li>
                <li className="flex items-start"><i className="ri-add-line text-amber-600 mr-2 md:mr-3 text-lg md:text-xl mt-1 font-bold"></i><span className="text-gray-800 text-sm md:text-base">Totem de autoatendimento</span></li>
                <li className="flex items-start"><i className="ri-add-line text-amber-600 mr-2 md:mr-3 text-lg md:text-xl mt-1 font-bold"></i><span className="text-gray-800 text-sm md:text-base">Controle de unidades</span></li>
                <li className="flex items-start"><i className="ri-add-line text-amber-600 mr-2 md:mr-3 text-lg md:text-xl mt-1 font-bold"></i><span className="text-gray-800 text-sm md:text-base">Integrações</span></li>
                <li className="flex items-start"><i className="ri-add-line text-amber-600 mr-2 md:mr-3 text-lg md:text-xl mt-1 font-bold"></i><span className="text-gray-800 text-sm md:text-base">Emissão de Cupom Fiscal</span></li>
              </ul>
              
              <a 
                href={getWhatsappUrl('Business')}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-gray-800 hover:bg-gray-900 text-white py-3 md:py-4 rounded-2xl font-bold transition-all duration-300 block text-center whitespace-nowrap cursor-pointer text-base md:text-lg"
              >
                Contratar agora
              </a>
            </div>
          </div>

          <div className="text-center mb-6 md:mb-8 mt-6 md:mt-8">
            <p className="text-xs md:text-sm text-gray-500 italic">
              * Oferecemos serviço de cadastro de cardápio (consulte valores à parte)
            </p>
          </div>
        </div>
      </section>

      {/* SEÇÃO 8 - Funcionalidades */}
      <section className="py-12 md:py-16 relative overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-10"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20restaurant%20technology%20dashboard%20interface%2C%20digital%20ordering%20system%20screens%2C%20point%20of%20sale%20terminals%2C%20QR%20code%20menus%2C%20professional%20food%20service%20technology%2C%20realistic%20photography%2C%20high%20quality%20commercial%20image&width=1920&height=800&seq=features-bg&orientation=landscape')`
          }}
        ></div>
        <div className="container mx-auto px-4 relative z-10 max-w-7xl">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-8 md:mb-12 text-gray-900">Funcionalidades completas</h2>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {[
              { icon: 'ri-smartphone-line', name: 'Site de pedidos delivery', color: 'from-blue-400 to-blue-600' },
              { icon: 'fab fa-whatsapp', name: 'Robô WhatsApp', color: 'from-green-400 to-green-600' },
              { icon: 'ri-computer-line', name: 'Totem', color: 'from-purple-400 to-purple-600' },
              { icon: 'ri-restaurant-2-line', name: 'Mesa do Garçom', color: 'from-red-400 to-red-600' },
              { icon: 'ri-cash-line', name: 'PDV', color: 'from-yellow-400 to-yellow-600' },
              { icon: 'ri-heart-line', name: 'Fidelização', color: 'from-pink-400 to-pink-600' },
              { icon: 'ri-shopping-cart-line', name: 'Abandono de carrinho', color: 'from-orange-400 to-orange-600' },
              { icon: 'ri-megaphone-line', name: 'Marketing', color: 'from-indigo-400 to-indigo-600' },
              { icon: 'ri-coupon-line', name: 'Cupons', color: 'from-teal-400 to-teal-600' },
              { icon: 'ri-building-line', name: 'Controle de unidades', color: 'from-cyan-400 to-cyan-600' },
              { icon: 'ri-plug-line', name: 'Integrações', color: 'from-lime-400 to-lime-600' },
              { icon: 'ri-dashboard-line', name: 'Painel', color: 'from-amber-400 to-amber-600' }
            ].map((feature, index) => (
              <div key={index} className="bg-white p-4 md:p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                <div className={`w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br ${feature.color} rounded-xl flex items-center justify-center mx-auto mb-3 md:mb-4 shadow-md`}>
                  <i className={`${feature.icon} text-white text-xl md:text-2xl`}></i>
                </div>
                <p className="text-center font-bold text-gray-900 text-sm md:text-base">{feature.name}</p>
              </div>
            ))}
          </div>
          
          <p className="text-center text-xl md:text-2xl font-bold mt-6 md:mt-8 text-gray-700">...e muito mais</p>
          
          <div className="text-center mt-6 md:mt-8">
            <a 
              href={getWhatsappUrl()}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black px-6 md:px-10 py-3 md:py-4 rounded-full font-bold text-base md:text-lg transition-all duration-300 transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer inline-block"
            >
              Ver todas as funcionalidades
            </a>
          </div>
        </div>
      </section>

      {/* SEÇÃO 9 - Sobre o BYPEDI */}
      <section className="py-12 md:py-16 relative overflow-hidden bg-gradient-to-br from-amber-50 via-white to-amber-50">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 right-0 w-96 h-96 bg-amber-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-yellow-500 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-4 max-w-5xl relative z-10">
          <div className="text-center">
            <h2 className="text-2xl md:text-4xl font-bold mb-6 md:mb-8 text-gray-900">Sobre o BYPEDI</h2>
            <div className="bg-white/80 backdrop-blur-sm p-6 md:p-10 rounded-3xl shadow-xl border border-amber-200">
              <p className="text-lg md:text-2xl text-gray-800 leading-relaxed">
                O BYPEDI nasceu para dar autonomia aos estabelecimentos de food service. Nossa plataforma é focada em aumentar vendas, fidelizar clientes e reduzir custos com plataformas terceiras. Atendemos restaurantes, pizzarias, hamburguerias, lanchonetes, padarias e muito mais.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SEÇÃO 10 - FAQ */}
      <section className="py-12 md:py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-3 md:mb-4 text-gray-900">❓ Perguntas Frequentes</h2>
          <p className="text-center text-lg md:text-xl text-gray-600 mb-8 md:mb-12">Tire suas dúvidas sobre o BYPEDI</p>
          
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-gradient-to-r from-gray-50 to-white rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 border border-gray-200">
                <button
                  onClick={() => setFaqOpen(faqOpen === index ? null : index)}
                  className="w-full text-left p-4 md:p-6 flex justify-between items-center cursor-pointer"
                >
                  <span className="font-bold text-base md:text-lg text-gray-900 pr-3 md:pr-4">{faq.q}</span>
                  <i className={`ri-arrow-${faqOpen === index ? 'up' : 'down'}-s-line text-xl md:text-2xl text-amber-600 flex-shrink-0`}></i>
                </button>
                {faqOpen === index && (
                  <div className="px-4 md:px-6 pb-4 md:pb-6">
                    <p className="text-gray-700 text-base md:text-lg leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SEÇÃO 11 - CTA Final */}
      <section 
        className="py-16 md:py-20 relative overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.75) 100%), url('https://readdy.ai/api/search-image?query=Successful%20restaurant%20owner%20celebrating%20business%20growth%2C%20modern%20food%20delivery%20service%20success%2C%20happy%20entrepreneur%20with%20smartphone%20showing%20sales%20dashboard%2C%20professional%20business%20photography%2C%20realistic%20high%20quality%20image&width=1920&height=600&seq=cta-final&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 text-center text-white relative z-10 max-w-5xl">
          <h2 className="text-2xl md:text-5xl font-extrabold mb-6 md:mb-8 leading-tight drop-shadow-2xl">
            Pronto para vender mais sem pagar comissões?
          </h2>
          <p className="text-lg md:text-2xl mb-8 md:mb-12 text-gray-200 drop-shadow-lg">
            Clique no botão abaixo e fale com um especialista agora mesmo.
          </p>
          
          <a 
            href={getWhatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black px-8 md:px-16 py-4 md:py-6 rounded-full text-lg md:text-2xl font-bold transition-all duration-300 transform hover:scale-110 shadow-2xl whitespace-nowrap mb-6 md:mb-8 cursor-pointer"
            style={{ animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' }}
          >
            Quero iniciar agora
          </a>
        </div>
      </section>

      {/* Footer - Compacto em linha única */}
      <footer className="bg-gradient-to-br from-gray-900 to-black text-white py-3 md:py-4">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0 text-center">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/8ae6a4d61264bced6ad2678c7de077f2/1fa7310747d5d29c80fc98c760d9f093.png" 
                alt="BYPEDI Logo" 
                className="h-6 md:h-8"
              />
            </div>
            <div className="flex flex-col md:flex-row items-center space-y-1 md:space-y-0 md:space-x-4 lg:space-x-6">
              <p className="text-gray-400 text-xs md:text-sm">© 2024 BYPEDI. Todos os direitos reservados.</p>
              <p className="text-gray-400 text-xs md:text-sm">📞 +55 14 99153-3587</p>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer text-xs md:text-sm"
              >
                Com tecnologia Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}